import React, { useState, useRef, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Individual.css";
import { Upload, Eye, CheckCircle } from "lucide-react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Card,
  Alert,
} from "react-bootstrap";
import { Trash2 } from "lucide-react";
import Footer from "./Footer";
import Navbar from "./Navbar";
import Explore from "./Explore";
import Overview from "./Overview";

const Carloan = () => {
  const [validated, setValidated] = useState(false);
  const [isPincodeValid, setIsPincodeValid] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [models, setModels] = useState([]);
  const [image, setImage] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const fileInputRef = useRef(null);
  const [notificationMessage, setNotificationMessage] = useState("");
  const [listener, setListener] = useState(null);
  const [variants, setVariants] = useState([]);
  const [formData, setFormData] = useState({
    fullName: "",
    mobileNumber: "",
    emailId: "",
    dateOfBirth: "",
    pincode: "",
    city: "",
    state: "",
    panDetails: "",
    address: "",
    employmentType: "",
    annualIncome: "",
    requiredLoanAmount: "",
    vehicleManufacturer: "",
    vehicleModel: "",
    vehicleVariant: "",
    documentType: "",
    loanProvider: "",
    termsAccepted: false,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  const vehicleData = {
    "Maruti Suzuki": {
      models: [
        "Alto K10",
        "Wagon R",
        "Swift",
        "Dzire",
        "Baleno",
        "Ertiga",
        "Brezza",
        "Grand Vitara",
        "Jimny",
      ],
      variants: ["LXi", "VXi", "ZXi", "ZXi+", "Alpha", "Zeta", "Sigma"],
    },
    Hyundai: {
      models: [
        "Grand i10 Nios",
        "i20",
        "Aura",
        "Venue",
        "Creta",
        "Verna",
        "Creta Electric",
      ],
      variants: ["Era", "Magna", "Sportz", "SX", "SX(O)", "N Line"],
    },
    "Tata Motors": {
      models: [
        "Tiago",
        "Tigor",
        "Altroz",
        "Punch",
        "Nexon",
        "Harrier",
        "Safari",
        "Tiago.ev",
        "Punch.ev",
        "Curvv",
      ],
      variants: ["XE", "XM", "XT", "XZ", "XZ+", "XZ+ Lux", "Dark Edition"],
    },
    "Mahindra & Mahindra": {
      models: [
        "Bolero",
        "Scorpio-N",
        "Thar",
        "XUV300",
        "XUV400",
        "XUV700",
        "Thar ROXX",
      ],
      variants: ["MX", "AX3", "AX5", "AX7", "AX7 L", "Z2", "Z4", "Z6", "Z8"],
    },
    Kia: {
      models: ["Sonet", "Seltos", "Carens", "EV6", "Carnival", "Syros"],
      variants: ["HTE", "HTK", "HTK+", "HTX", "HTX+", "GTX+", "X-Line"],
    },
    Toyota: {
      models: [
        "Glanza",
        "Urban Cruiser Hyryder",
        "Innova Crysta",
        "Innova Hycross",
        "Fortuner",
      ],
      variants: ["E", "G", "V", "VX", "ZX", "ZX(O)"],
    },
    Honda: {
      models: ["Amaze", "City", "Elevate"],
      variants: ["E", "S", "V", "VX", "ZX"],
    },
    Renault: {
      models: ["Kwid", "Triber", "Kiger"],
      variants: ["RXE", "RXL", "RXT", "RXZ"],
    },
    Nissan: {
      models: ["Magnite"],
      variants: ["XE", "XL", "XV", "XV Premium"],
    },
    "MG Motor": {
      models: [
        "Astor",
        "Hector",
        "Hector Plus",
        "Gloster",
        "ZS EV",
        "Comet EV",
      ],
      variants: ["Style", "Super", "Smart", "Sharp", "Savvy"],
    },
    Volkswagen: {
      models: ["Polo", "Vento", "Virtus", "Taigun", "Tiguan"],
      variants: ["Comfortline", "Highline", "Topline", "GT"],
    },
    Skoda: {
      models: ["Slavia", "Kushaq", "Kodiaq", "Superb"],
      variants: ["Active", "Ambition", "Style", "Laurin & Klement (L&K)"],
    },
    BMW: {
      models: ["3 Series", "5 Series", "X1", "X3", "X5", "X7"],
      variants: ["Sport", "Luxury Line", "M Sport"],
    },
    "Mercedes-Benz": {
      models: [
        "A-Class Limousine",
        "C-Class",
        "E-Class",
        "S-Class",
        "GLA",
        "GLC",
        "GLE",
        "GLS",
        "EQS",
      ],
      variants: ["Progressive", "AMG Line", "4MATIC"],
    },
    Audi: {
      models: ["A4", "A6", "Q3", "Q5", "Q7", "e-tron"],
      variants: ["Premium", "Premium Plus", "Technology", "Performance"],
    },
  };

  const handleChange = async (e) => {
    const { name, value, type, checked } = e.target;
    const fieldValue = type === "checkbox" ? checked : value;

    // Update form data
    setFormData((prev) => ({
      ...prev,
      [name]: fieldValue,
    }));

    // Handle Manufacturer Change
    if (name === "vehicleManufacturer") {
      const selectedData = vehicleData[value] || { models: [], variants: [] };

      setModels(selectedData.models);
      setVariants([]); // Reset variants when manufacturer changes

      setFormData((prev) => ({
        ...prev,
        vehicleModel: "",
        vehicleVariant: "",
      }));
    }

    // Handle Model Change
    if (name === "vehicleModel") {
      const selectedManufacturer = formData.vehicleManufacturer;
      const selectedVariants =
        vehicleData[selectedManufacturer]?.variants || [];

      setVariants(selectedVariants);

      setFormData((prev) => ({
        ...prev,
        vehicleVariant: "",
      }));
    }

    // Handle Pincode Logic
    if (name === "pincode") {
      if (value.length === 6 && isValidPincode(value)) {
        try {
          const response = await fetch(
            `https://api.postalpincode.in/pincode/${value}`
          );
          const data = await response.json();

          if (data[0].Status === "Success") {
            const postOffice = data[0].PostOffice[0];

            setFormData((prev) => ({
              ...prev,
              city: postOffice.District,
              state: postOffice.State,
            }));
            setIsPincodeValid(true);
          } else {
            setFormData((prev) => ({
              ...prev,
              city: "",
              state: "",
            }));
            setIsPincodeValid(false);
          }
        } catch (error) {
          console.error("Pincode API error", error);
          setIsPincodeValid(false);
        }
      } else {
        setFormData((prev) => ({
          ...prev,
          city: "",
          state: "",
        }));
        setIsPincodeValid(false);
      }
    }
  };

  const isValidPincode = (pin) => {
    return /^[1-9][0-9]{5}$/.test(pin);
  };

  const resetForm = () => {
    setFormData({
      fullName: "",
      mobileNumber: "",
      emailId: "",
      dateOfBirth: "",
      pincode: "",
      city: "",
      state: "",
      panDetails: "",
      address: "",
      employmentType: "",
      annualIncome: "",
      requiredLoanAmount: "",
      vehicleManufacturer: "",
      vehicleModel: "",
      vehicleVariant: "",
      documentType: "",
      loanProvider: "",
      termsAccepted: false,
    });
    setValidated(false);
    setIsPincodeValid(false);
    setModels([]);
    setVariants([]);
    setImage(null);
    setShowPreview(false);
    setShowOptions(false);
    setShowNotification(false);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    const isFormValid = form.checkValidity();
    const isAddressValid = formData.address.trim().length >= 10;

    if (!isFormValid || !isAddressValid) {
      event.stopPropagation();
      setValidated(true);
      return;
    }

    console.log("Form submitted. Here are the details:");
    Object.entries(formData).forEach(([key, value]) => {
      console.log(`${key}: ${value}`);
    });

    setShowSuccess(true);
    setTimeout(() => {
      setShowSuccess(false);
      resetForm();
    }, 3000);

    setValidated(true);
  };

    useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const states = [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
    "Delhi",
    "Jammu and Kashmir",
    "Ladakh",
    "Puducherry",
    "Chandigarh",
    "Andaman and Nicobar Islands",
    "Dadra and Nagar Haveli and Daman and Diu",
    "Lakshadweep",
  ];

  const documentTypes = [
    "Aadhar Card",
    "Voter ID",
    "Driving License",
    "Passport",
  ];

  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  const handlePreviewClick = () => {
    setShowPreview(!showPreview);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setImage(e.target.result);
        setShowPreview(true);

        setNotificationMessage("Your image was successfully uploaded!");
        setShowNotification(true);

        setTimeout(() => {
          setShowNotification(false);
        }, 3000);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleDeleteImage = () => {
    setImage(null);
    setShowPreview(false);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }

    setNotificationMessage("Your image was successfully deleted!");
    setShowNotification(true);

    setTimeout(() => {
      setShowNotification(false);
    }, 3000);
  };

  return (
    <>
      <Navbar />
      <div className="row justify-content-center align-items-center text-center">
        <div
          className="position-absolute start-0 w-100 h-100"
          style={{
            background:
              "radial-gradient(circle at top right, #A0FFFFCC 22%, transparent 88px)",
            filter: "blur(88px)",
            zIndex: 0,
          }}
        ></div>
        <div className="container-fluid pt-lg-5 mt-5">
          <div className="row">
            <div className="col-12">
              <h2 className="fw-bold mt-5 mb-3">Car Loan</h2>
            </div>
          </div>
        </div>

        <Card.Header className="text-secondary d-flex justify-content-center align-items-center rounded-4">
          <h5 className="mb-5 m-auto fs-6 ">
            To apply for a Car Loan, please <br /> fill the details below
          </h5>
        </Card.Header>
      </div>
      <section
        className="insurance-service position-relative overflow-hidden"
        style={{
          background:
            "linear-gradient(180deg, rgba(255, 255, 255, 1) 40%, #F5F2FF 100%, rgba(255, 255, 255, 1) 100%)",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Container className=" rounded-4 mb-4">
          <Card className="border-0 rounded-5">
            <Card.Body className="bg-light rounded-5">
              {showSuccess && (
                <Alert
                  variant="success"
                  onClose={() => setShowSuccess(false)}
                  dismissible
                >
                  Your application has been submitted successfully!
                </Alert>
              )}

              <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <Card className="mb-3 mt-4 rounded-4">
                  <Card.Body>
                    <h5 className="mb-3 mt-4">Personal details</h5>
                    <Row className="mb-0 mb-sm-2">
                      <Col md={4} className="mb-2 mb-md-0">
                        <Form.Group controlId="fullName">
                          <Form.Label>Full Name</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Name (as per PAN Card)"
                            name="fullName"
                            value={formData.fullName}
                            onChange={handleChange}
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            Please provide your full name.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-2 mb-md-0">
                        <Form.Group controlId="mobileNumber">
                          <Form.Label>Mobile Number</Form.Label>
                          <Form.Control
                            type="tel"
                            placeholder="OTP will be sent after you click 'Apply'"
                            name="mobileNumber"
                            value={formData.mobileNumber}
                            onChange={handleChange}
                            pattern="[0-9]{10}"
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            Please provide a valid 10-digit mobile number.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-2 mb-md-0">
                        <Form.Group controlId="emailId">
                          <Form.Label>Email ID</Form.Label>
                          <Form.Control
                            type="email"
                            placeholder="Enter your email ID"
                            name="emailId"
                            value={formData.emailId}
                            onChange={handleChange}
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            Please provide a valid email.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row className="mb-0 mb-sm-2">
                      <Col md={4} className="mb-2 mb-md-0">
                        <Form.Group controlId="dateOfBirth">
                          <Form.Label>Date of Birth</Form.Label>
                          <Form.Control
                            type="date"
                            placeholder="(dd/mm/yyyy)"
                            name="dateOfBirth"
                            value={formData.dateOfBirth}
                            onChange={handleChange}
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            Please provide your date of birth.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-2 mb-md-0">
                        <Form.Group controlId="panDetails">
                          <Form.Label>PAN details</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter PAN number"
                            name="panDetails"
                            value={formData.panDetails}
                            onChange={handleChange}
                            pattern="[A-Z]{5}[0-9]{4}[A-Z]{1}"
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            Please provide a valid PAN number.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-2 mb-md-0">
                        <Form.Group controlId="aadharDetails">
                          <Form.Label>Aadhar details</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter Aadhar number"
                            name="aadharDetails"
                            value={formData.aadharDetails}
                            onChange={handleChange}
                            pattern="[0-9]{12}"
                            maxLength="12"
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            Please provide a valid 12-digit Aadhar number.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row className="mb-0 mb-sm-2">
                      <Col md={4} className="mb-2 mb-md-0">
                        <Form.Group controlId="pincode">
                          <Form.Label>Pincode</Form.Label>
                          <Form.Control
                            type="text"
                            name="pincode"
                            value={formData.pincode}
                            onChange={handleChange}
                            isInvalid={validated && !isPincodeValid}
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            Please enter a valid 6-digit pincode.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-2 mb-md-0">
                        <Form.Group controlId="city">
                          <Form.Label>City</Form.Label>
                          <Form.Control
                            type="text"
                            name="city"
                            value={formData.city}
                            readOnly
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            City will be auto-filled from pincode.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col md={4} className="mb-2 mb-md-0">
                        <Form.Group controlId="state">
                          <Form.Label>State</Form.Label>
                          <Form.Control
                            type="text"
                            name="state"
                            value={formData.state}
                            readOnly
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            State will be auto-filled from pincode.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row className="mb-0 mb-sm-2">
                      <Col md={4} className="mb-2 mb-md-0">
                        <Form.Group controlId="address">
                          <Form.Label>Address</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Give full address"
                            name="address"
                            value={formData.address}
                            onChange={handleChange}
                            isInvalid={
                              validated && formData.address.trim().length < 10
                            }
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            Please provide a valid full address (minimum 10
                            characters).
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-2 mb-md-0">
                        <Form.Group controlId="documentType">
                          <Form.Label>Select any one document</Form.Label>
                          <Form.Select
                            name="documentType"
                            value={formData.documentType}
                            onChange={handleChange}
                            required
                          >
                            <option value="">Select</option>
                            {documentTypes.map((doc, index) => (
                              <option key={index} value={doc}>
                                {doc}
                              </option>
                            ))}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            Please select a document type.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-2 mb-md-0">
                        <Form.Group controlId="employmentType">
                          <Form.Label>Employment Type</Form.Label>
                          <Form.Select
                            name="employmentType"
                            value={formData.employmentType}
                            onChange={handleChange}
                            required
                          >
                            <option value="">Select</option>
                            <option value="Salaried">Salaried</option>
                            <option value="Self-Employed">Self-Employed</option>
                            <option value="Business Owner">
                              Business Owner
                            </option>
                            <option value="Retired">Retired</option>
                            <option value="Student">Student</option>
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            Please select an employment type.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-0 mb-sm-2">
                      <Col md={4} className="mb-2 mb-md-0">
                        <Form.Group controlId="annualIncome">
                          <Form.Label>Annual Income (in ₹)</Form.Label>
                          <Form.Control
                            type="number"
                            name="annualIncome"
                            value={formData.annualIncome}
                            onChange={handleChange}
                            placeholder="Enter income"
                            min="0"
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            Please enter your annual income.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-2 mb-md-0">
                        <Form.Group controlId="requiredLoanAmount">
                          <Form.Label>Required Loan Amount</Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter loan amount"
                            name="requiredLoanAmount"
                            value={formData.requiredLoanAmount}
                            onChange={handleChange}
                            min="1000"
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            Please enter a valid loan amount.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-2 mb-md-0">
                        <Form.Group controlId="loanProvider">
                          <Form.Label>Bank Loan Provider</Form.Label>
                          <Form.Select
                            name="loanProvider"
                            value={formData.loanProvider}
                            onChange={handleChange}
                            required
                          >
                            <option value="">Select</option>
                            <option value="HDFC Bank">HDFC Bank</option>
                            <option value="ICICI Bank">ICICI Bank</option>
                            <option value="State Bank of India (SBI)">
                              State Bank of India (SBI)
                            </option>
                            <option value="Axis Bank">Axis Bank</option>
                            <option value="Kotak Mahindra Bank">
                              Kotak Mahindra Bank
                            </option>
                            <option value="Bank of Baroda">
                              Bank of Baroda
                            </option>
                            <option value="Punjab National Bank (PNB)">
                              Punjab National Bank (PNB)
                            </option>
                            <option value="IDFC FIRST Bank">
                              IDFC FIRST Bank
                            </option>
                            <option value="Yes Bank">Yes Bank</option>
                            <option value="IndusInd Bank">IndusInd Bank</option>
                            <option value="Federal Bank">Federal Bank</option>
                            <option value="Union Bank of India">
                              Union Bank of India
                            </option>
                            <option value="Canara Bank">Canara Bank</option>
                            <option value="Tata Capital">Tata Capital</option>
                            <option value="Mahindra Finance">
                              Mahindra Finance
                            </option>
                            <option value="Bajaj Finserv">Bajaj Finserv</option>
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            Please select a bank loan provider.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Row className="mb-3 mb-sm-2 d-flex justify-content-start align-items-start">
                        <Col xs={12} md={6}>
                          <Form.Group controlId="personalImage">
                            <Form.Label className="mb-3 mt-3 d-flex align-items-center justify-content-start">
                              Upload Passport Size Image{" "}
                            </Form.Label>

                            {image && (
                              <div className="mb-3 d-flex justify-content-center gap-2">
                                <button
                                  type="button"
                                  className="btn btn-success d-flex align-items-center justify-content-center gap-2"
                                  style={{ width: "145px" }}
                                  onClick={handlePreviewClick}
                                >
                                  <Eye size={16} />
                                  <span className="d-none d-sm-inline">
                                    {showPreview ? "Hide" : "Preview"}
                                  </span>
                                  <span className="d-sm-none">
                                    {showPreview ? "Hide" : "View"}
                                  </span>
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-danger d-flex align-items-center justify-content-center gap-2"
                                  style={{ width: "145px" }}
                                  onClick={handleDeleteImage}
                                >
                                  <Trash2 size={16} />
                                  <span className="d-none d-sm-inline">
                                    Delete
                                  </span>
                                  <span className="d-sm-none">Delete</span>
                                </button>
                              </div>
                            )}

                            <div className="mb-3 d-flex justify-content-start">
                              <div
                                className={`border rounded ${
                                  !image ? "border-2" : ""
                                }`}
                                style={{
                                  width:
                                    image && showPreview ? "auto" : "150px",
                                  height:
                                    image && showPreview ? "auto" : "200px",
                                  maxWidth: "300px",
                                  maxHeight: "400px",
                                  backgroundColor: !image ? "#f8f9fa" : "white",
                                  cursor: !image ? "pointer" : "default",
                                  position: "relative",
                                  overflow: "hidden",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                                onClick={!image ? triggerFileInput : undefined}
                              >
                                {image && showPreview && (
                                  <img
                                    src={image}
                                    alt="Passport size preview"
                                    className="img-fluid rounded"
                                    style={{
                                      maxWidth: "100%",
                                      maxHeight: "100%",
                                      objectFit: "contain",
                                      width: "auto",
                                      height: "auto",
                                    }}
                                  />
                                )}

                                {image && !showPreview && (
                                  <div className="d-flex flex-column align-items-center justify-content-center text-muted h-100">
                                    <Upload className="mb-2" size={32} />
                                    <p className="text-center mb-0 small">
                                      Preview hidden
                                    </p>
                                  </div>
                                )}

                                {!image && (
                                  <div className="d-flex flex-column align-items-center justify-content-center text-muted h-100 p-2">
                                    <div
                                      className="border-2 border-dashed border-secondary rounded mb-2 d-flex align-items-center justify-content-center"
                                      style={{
                                        width: "100px",
                                        height: "130px",
                                        backgroundColor: "#ffffff",
                                      }}
                                    >
                                      <Upload size={32} />
                                    </div>
                                    <p className="text-center mb-0 small">
                                      <span className="d-none d-sm-inline">
                                        Click to upload
                                      </span>
                                      <span className="d-sm-none">
                                        Tap to upload
                                      </span>
                                    </p>
                                    <small className="text-center text-muted">
                                      Passport Size
                                    </small>
                                    <small className="text-center text-muted">
                                      <span className="d-none d-md-inline">
                                        JPG, PNG
                                      </span>
                                      <span className="d-md-none">JPG/PNG</span>
                                    </small>
                                  </div>
                                )}

                                {!image && (
                                  <div
                                    className="position-absolute"
                                    style={{
                                      top: "10px",
                                      right: "10px",
                                      fontSize: "10px",
                                      color: "#6c757d",
                                      backgroundColor: "rgba(255,255,255,0.8)",
                                      padding: "2px 4px",
                                      borderRadius: "2px",
                                    }}
                                  >
                                    3.5×4.5 cm
                                  </div>
                                )}
                              </div>
                            </div>

                            {showNotification && (
                              <div
                                className="position-fixed top-0 end-0 p-3"
                                style={{ zIndex: 1055 }}
                              >
                                <div className="toast show" role="alert">
                                  <div className="toast-header">
                                    <CheckCircle
                                      className="me-2 text-success"
                                      size={20}
                                    />
                                    <strong className="me-auto">Success</strong>
                                    <button
                                      type="button"
                                      className="btn-close"
                                      onClick={() => setShowNotification(false)}
                                    ></button>
                                  </div>
                                  <div className="toast-body">
                                    {notificationMessage}
                                  </div>
                                </div>
                              </div>
                            )}

                            <input
                              type="file"
                              ref={fileInputRef}
                              onChange={handleFileChange}
                              accept="image/*"
                              className="d-none"
                              required
                            />

                            <Form.Control.Feedback type="invalid">
                              Please upload a passport size personal image.
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      </Row>
                    </Row>
                  </Card.Body>
                </Card>

                <Card className="mb-2 rounded-4">
                  <Card.Body>
                    <h5 className="mb-3">Car details</h5>
                    <Row className="mb-3 mb-sm-1">
                      <Col md={4} className="mb-2 mb-md-0">
                        <Form.Group controlId="vehicleManufacturer">
                          <Form.Label>Manufacturer</Form.Label>
                          <Form.Select
                            name="vehicleManufacturer"
                            value={formData.vehicleManufacturer}
                            onChange={handleChange}
                            required
                          >
                            <option value="">Select Manufacturer</option>
                            {Object.keys(vehicleData).map((manufacturer) => (
                              <option key={manufacturer} value={manufacturer}>
                                {manufacturer}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>

                      <Col md={4} className="mb-2 mb-md-0">
                        <Form.Group controlId="vehicleModel">
                          <Form.Label>Model</Form.Label>
                          <Form.Select
                            name="vehicleModel"
                            value={formData.vehicleModel}
                            onChange={handleChange}
                            required
                            disabled={models.length === 0}
                          >
                            <option value="">Select Model</option>
                            {models.map((model, index) => (
                              <option key={index} value={model}>
                                {model}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>

                      <Col md={4} className="mb-2 mb-md-0">
                        <Form.Group controlId="vehicleVariant">
                          <Form.Label>Variant</Form.Label>
                          <Form.Select
                            name="vehicleVariant"
                            value={formData.vehicleVariant}
                            onChange={handleChange}
                            required
                            disabled={variants.length === 0}
                          >
                            <option value="">Select Variant</option>
                            {variants.map((variant, index) => (
                              <option key={index} value={variant}>
                                {variant}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>

                <Row className="mb-3">
                  <Col>
                    <Form.Group controlId="termsAccepted">
                      <Form.Check
                        type="checkbox"
                        name="termsAccepted"
                        checked={formData.termsAccepted}
                        onChange={handleChange}
                        label={
                          <span>
                            By submitting the application, I agree and accept
                            the Terms and Conditions as specified{" "}
                            <a href="/" className="text-primary">
                              here
                            </a>
                          </span>
                        }
                        required
                      />
                      <Form.Control.Feedback type="invalid">
                        You must agree to the terms and conditions.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>

                <div className="d-flex gap-3">
                  <Button
                    variant="primary"
                    type="submit"
                    className="px-4 py-2 "
                  >
                    Apply
                  </Button>
                  <Button
                    variant="outline-light bg-primary text-white px-4 py-2 "
                    onClick={resetForm}
                  >
                    Clear
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Container>
      </section>

      <section
        style={{
          backgroundColor: "rgba(200, 190, 238, 0.2)",
          backdropFilter: "blur(5px)",
          WebkitBackdropFilter: "blur(8px)",
          padding: "0.5rem",
        }}
      >
        <Container className="border-0">
          <Card
            className="mb-4 mt-4 border-0"
            style={{
              borderRadius: "15px",
              backgroundColor: "rgba(200, 190, 238, 0.2)",
            }}
          >
            <Card.Body
              style={{
                borderRadius: "15px",
                backgroundColor: " #DFE2FF",
                backdropFilter: "blur(8px)",
                WebkitBackdropFilter: "blur(8px)",
              }}
            >
              <h5 className="fw-bold mb-3 text-dark">Important Notice</h5>

              <p className="text-muted mb-3">
                At Shubh Paisa, we are committed to making homeownership a
                reality, not a burden. Our home loan solutions come with
                customized repayment plans, flexible tenures, and competitive
                interest rates to ensure that your financial stability remains
                intact.
              </p>

              <h6 className="fw-bold mb-2 text-dark">
                Things to Keep in Mind Before Applying:
              </h6>

              <ul className="text-muted mb-3 ps-3">
                <li className="mb-2">
                  <strong>Eligibility Matters</strong> – Your credit score,
                  income, and financial history play a role in approval.
                </li>
                <li className="mb-2">
                  <strong>Loan Tenure & EMI Calculation</strong> – A longer
                  tenure means smaller EMIs, but a shorter tenure means less
                  interest paid over time.
                </li>
                <li className="mb-2">
                  <strong>Interest Rate Types</strong> – Choose between fixed
                  and floating rates to suit your needs.
                </li>
              </ul>

              <p className="text-muted fw-semibold mb-0">
                <strong>Hidden Charges? Not Here!</strong> – We believe in
                transparency—no surprise costs, no hidden fees.
              </p>
            </Card.Body>
          </Card>
        </Container>
      </section>
      <Overview />
      <Explore />
      <Footer />
    </>
  );
};

export default Carloan;
